export const visit = (vm, at) => {
vm(require("share-transcript-modal/lang/en.lyaml"));
vm(require("recording-review-components-lib/lang/en.lyaml"));
at({ "en": { "transcriptSidebar": { "title": "Recording Review" } } });
};